import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { motion } from 'motion/react'
import type { PropsWithChildren, ReactElement } from 'react'
import { themeClass } from '~/styles/theme.css'
import { actionLabel, dismissIcon, wrapper } from './ActionBar.css'

type ActionBarProps = PropsWithChildren & {
  onDismiss?: () => void
  text: string
}

const ActionBar = ({
  onDismiss,
  text = '',
  children
}: ActionBarProps): ReactElement => {
  return (
    <motion.div
      key="action-bar"
      initial={{ opacity: 0, y: 20, x: '-50%' }}
      animate={{ opacity: 1, y: 0, x: '-50%' }}
      exit={{ opacity: 0, y: 20, x: '-50%' }}
      className={clsx(themeClass, wrapper)}
    >
      {onDismiss !== null && (
        <span onClick={onDismiss} className={dismissIcon}>
          <FontAwesomeIcon icon={faXmark} />
        </span>
      )}
      <span className={actionLabel}>{text}</span>
      {children}
    </motion.div>
  )
}

export default ActionBar
